import { request } from '.';

export type JoinRequestStatus = 'PENDING' | 'APPROVED' | 'REJECTED';

export type JoinRequest = {
  id: number;
  fk_empresa_id: number;
  fk_portal_account_id: number | null;
  requester_name: string | null;
  requester_email: string;
  status: JoinRequestStatus;
  reviewed_at: string | null;
  rejection_reason: string | null;
  created_at: string;
  empresa: { id: number; trade_name: string } | null;
};

export const getJoinRequests = async (status?: JoinRequestStatus): Promise<JoinRequest[]> => {
  const params = status ? { status } : {};
  const { data } = await request.get<JoinRequest[]>('/sso/join-requests', { params });
  return data;
};

export const approveJoinRequest = async (id: number): Promise<void> => {
  await request.post(`/sso/join-requests/${id}/approve`);
};

export const rejectJoinRequest = async (id: number, reason?: string): Promise<void> => {
  await request.post(`/sso/join-requests/${id}/reject`, { reason: reason ?? '' });
};
